module.exports = __webpack_public_path__ + "static/media/okxWallet.8fd3a856.svg";